import {
  IconButton,
  Table,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import {
  TableCellFixedWidth,
  TableCellWide,
} from "../../../../common/components/functional/GroupedTable/styled";
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
  open: boolean;
  setOpen: () => void;
  hideCategoryNames: boolean;
};

export const ShortOrderWorkOffersHeader = ({
  title,
  open,
  setOpen,
  hideCategoryNames,
}: Props) => {
  const { t } = useTranslation("order");
  const borderStyle = "1px solid rgba(0, 10, 68, 0.11)";

  return (
    <Table size="small" sx={{ padding: 0, margin: 0 }}>
      <TableHead>
        <TableRow>
          <TableCellFixedWidth>
            <IconButton
              size="small"
              onClick={() => setOpen()}
              sx={{
                padding: 0,
                margin: 0,
                marginLeft: 1,
                color: "#4A1D9C",
              }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCellFixedWidth>
          <TableCellWide>
            <Typography color="primary" fontWeight={600} fontSize={14}>
              {title.toLocaleUpperCase()}
            </Typography>
          </TableCellWide>
          <TableCellFixedWidth
            sx={{
              borderLeft: borderStyle,
            }}
          >
            <Typography variant="secondary">
              {!hideCategoryNames &&
                t("offered").charAt(0).toUpperCase() + t("offered").slice(1)}
            </Typography>
          </TableCellFixedWidth>
          <TableCellFixedWidth
            sx={{
              borderLeft: borderStyle,
            }}
          >
            <Typography variant="secondary">
              {!hideCategoryNames &&
                t("accepted").charAt(0).toUpperCase() + t("accepted").slice(1)}
            </Typography>
          </TableCellFixedWidth>
          <TableCellFixedWidth
            sx={{
              borderLeft: borderStyle,
              borderRight: borderStyle,
            }}
          >
            <Typography variant="secondary">
              {!hideCategoryNames &&
                t("declined").charAt(0).toUpperCase() + t("declined").slice(1)}
            </Typography>
          </TableCellFixedWidth>
        </TableRow>
      </TableHead>
    </Table>
  );
};
